/**********************************************
 * Countdown timer that accounts for time drifting and exposes time updates through promises.
 * 
 * Times are in milliseconds. 
 * 
 * Example:
 * var c = new IREP.Countdown({ updateTime: 1000, totalTime: 50000 });
 * c.start().progress(function() { 
 *      console.log('timer update'); 
 * }).done(function() { 
 *      console.log('timer finished'); 
 * }).fail(function() { 
 *      console.log('timer was stopped'); 
 * });
 * c.stop();
 * 
 * OR 
 * 
 * IREP.Countdown({ updateTime: 1000, totalTime: 50000 }).start().progress(function() { 
 *      console.log('timer update'); 
 * }).done(function() { 
 *      console.log('timer finished'); 
 * }).fail(function() { 
 *      console.log('timer was stopped'); 
 * });
 * 
 **********************************************/
IREP.Countdown = (function () {
    var defaultOptions = {
        totalTime: 10000,
        updateTime: 1000,
        intervalResolution: 8, // don't change this unless you know what you're doing
    }

    var Countdown = function (options) {
        if (!(this instanceof Countdown)) {
            return new Countdown();
        }

        this.options = $.extend({}, defaultOptions, options);

        this.intervalID = 0;
        this.deferred = null;

        this.roundTimings = function(currentTime) {
            var trueElapsed = (currentTime - this.startTime);
            var steps = Math.floor(trueElapsed / this.options.updateTime);
            var elapsed = steps * this.options.updateTime;
            var remaining = this.options.totalTime - elapsed;
            return { elapsed: elapsed, remaining: remaining, steps: steps, trueElapsed: trueElapsed };
        };
    };

    Countdown.prototype.start = function () {
        var self = this;

        this.startTime = new Date().getTime();
        var startUpdate = self.startTime;
        var updateCount = 0;

        if (this.intervalID != 0) {
            this.stop();
        }

        this.deferred = $.Deferred();

        this.intervalID = setTimeout(function update() {
            var currentTime = new Date().getTime();
            var timeDiffFromStart = (currentTime - self.startTime);
            var timeDiffFromUpdate = (currentTime - startUpdate);

            if (timeDiffFromUpdate >= self.options.updateTime) {
                startUpdate = self.startTime + (++updateCount * self.options.updateTime);
                self.deferred.notifyWith(this, [self.roundTimings(currentTime)]);
            }

            if (timeDiffFromStart >= self.options.totalTime) {
                self.deferred.resolveWith(this, [self.roundTimings(currentTime)]);

                self.intervalID = 0;
                self.deferred = null;
            } else {
                self.intervalID = setTimeout(update, self.options.intervalResolution);
            }
        }, self.options.intervalResolution);

        return this.deferred.promise();
    };

    

    Countdown.prototype.stop = function (customArgs) {
        var currentTime = new Date().getTime();

        if (this.intervalID != 0) {
            clearInterval(this.intervalID);
            this.deferred.rejectWith(this, [this.roundTimings(currentTime), customArgs]);
            this.deferred = null;
            this.intervalID = 0;
        }
    };

    return Countdown;
}());